export enum BaseAssignmentType {
  PLANNED = 'planned',
  ACTIVE = 'active',
  ENDED = 'ended',
}
